import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoleInvoiceTemplateSelectComponent } from './sole-invoice-template-select.component';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PreloaderModule, ValidationErrorModule } from '@shared/component';

@NgModule({
  declarations: [
    SoleInvoiceTemplateSelectComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    ValidationErrorModule,
    PreloaderModule
  ],
  exports: [
    SoleInvoiceTemplateSelectComponent
  ]
})
export class SoleInvoiceTemplateSelectModule { }
